import { render, staticRenderFns } from "./DispatcherSetting.vue?vue&type=template&id=aa2436c2&"
import script from "./DispatcherSetting.vue?vue&type=script&lang=js&"
export * from "./DispatcherSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports